import { useAuth } from '@shared/components/AuthProvider';
import { useDesignParams } from '@apps/acquisitionFunnels/createWedding/hooks/useDesignParams';

/**
 * Checks if the create wedding page is ready.
 *
 * We need to check if the user is logged in and if the design params are settled.
 *
 * @param skipWaitForDesignParamToSettle - When true, bypasses the design params settlement check.
 *   Used by callers (e.g., public shop) that don't rely on design params.
 * @returns true if the create wedding page is ready, false otherwise.
 */
export const useIsCreateWeddingReady = (skipWaitForDesignParamToSettle?: boolean) => {
  const { isCurrentUserSettled } = useAuth();
  const { settled } = useDesignParams();

  return isCurrentUserSettled && (settled || !!skipWaitForDesignParamToSettle);
};
